{
  "market": {
    "common": {
      "conditions": {
        "new": "Neuf",
        "used": "Occasion",
        "refurbished": "Reconditionné"
      },
      "status": {
        "draft": "Brouillon",
        "published": "Publiée",
        "publishedProduct": "Publié",
        "disabled": "Désactivée",
        "disabledProduct": "Désactivé",
        "archived": "Archivée",
        "archivedProduct": "Archivé"
      },
      "sessionExpired": "Session expirée.",
      "sessionExpiredReconnect": "Session expirée — reconnectez-vous.",
      "sessionExpiredReconnect2": "Session expirée. Reconnectez-vous.",
      "networkError": "Problème de connexion. Réessayez.",
      "cannotLoad": "Impossible de charger.",
      "retry": "Réessayer",
      "loading": "Chargement…",
      "back": "Retour",
      "cancel": "Annuler",
      "save": "Enregistrer",
      "saving": "Enregistrement…",
      "copy": "Copier le lien",
      "copied": "Copié !",
      "seeMore": "Voir plus",
      "offlineText": "Pas de connexion internet"
    },
    "boutiques": {
      "searchPlaceholder": "Rechercher…",
      "headerCount_one": "{{count}} boutique",
      "headerCount_other": "{{count}} boutiques",
      "loadingNormal": "Recherche des meilleures boutiques…",
      "loadingSearch": "Recherche en cours…",
      "errorNormal": "Impossible de charger les boutiques actuellement.",
      "errorSearch": "Impossible de lancer la recherche.",
      "emptyNormal": "Aucune boutique publiée pour le moment.",
      "emptySearch": "Aucune boutique ne correspond à cette recherche.",
      "online": "En ligne",
      "productsCount_one": "{{count}} produit",
      "productsCount_other": "{{count}} produits",
      "subscribersCount_one": "{{count}} abonné",
      "subscribersCount_other": "{{count}} abonnés",
      "visit": "Visiter"
    },
    "creerBoutique": {
      "headerTitle": "Nouvelle boutique",
      "subtitle": "Donnez un nom à votre boutique. Vous pourrez personnaliser son apparence et ajouter des produits juste après.",
      "nameLabel": "Nom de la boutique",
      "namePlaceholder": "Ex : Atelier Wax & Co",
      "submit": "Créer la boutique"
    },
    "creerProduit": {
      "headerTitle": "Nouveau produit",
      "createButton": "Créer",
      "intro": "Remplissez votre fiche produit dès maintenant. Les champs marqués d'un astérisque sont obligatoires — le reste peut être complété ou modifié plus tard.",
      "sections": {
        "essential": "Essentiel",
        "details": "Détails",
        "advanced": "Options avancées",
        "advancedSubtitle": "Prix promo, devise, mise en avant, boutons d'action",
        "seo": "Référencement (SEO)",
        "seoSubtitle": "Comment ce produit apparaît dans les résultats de recherche et les partages"
      },
      "fields": {
        "nameLabel": "Nom du produit *",
        "namePlaceholder": "Ex : Collier perles wax",
        "priceLabel": "Prix ({{currency}}) *",
        "pricePlaceholder": "Ex : 8000",
        "categoryLabel": "Catégorie",
        "categoryPlaceholder": "Laissez vide pour « Autre »",
        "categoryHint": "Identifiant de la catégorie — un sélecteur remplacera bientôt ce champ.",
        "descriptionShortLabel": "Description courte",
        "descriptionShortPlaceholder": "Une phrase qui donne envie",
        "descriptionLabel": "Description complète",
        "descriptionPlaceholder": "Détaillez les caractéristiques, matières, dimensions…",
        "brandLabel": "Marque",
        "brandPlaceholder": "Ex : Fabriqué maison, Nike…",
        "conditionLabel": "État",
        "stockLabel": "Stock disponible",
        "stockPlaceholder": "Ex : 12",
        "stockHint": "Laissez vide pour démarrer à 0.",
        "skuLabel": "Référence (SKU)",
        "skuPlaceholder": "Ex : COL-WAX-001",
        "skuHint": "Doit être unique dans cette boutique si renseigné.",
        "promoPriceLabel": "Prix promotionnel",
        "promoPricePlaceholder": "Doit être inférieur ou égal au prix normal",
        "currencyLabel": "Devise",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Code ISO à 3 lettres (XOF, EUR, USD…).",
        "featuredLabel": "Mettre en avant ce produit",
        "seoTitleLabel": "Titre SEO",
        "seoTitlePlaceholder": "Titre affiché dans les résultats de recherche",
        "seoDescriptionLabel": "Description SEO",
        "seoDescriptionPlaceholder": "Résumé affiché sous le titre dans les recherches"
      },
      "actionButtons": {
        "groupLabel": "Boutons d'action",
        "whatsapp": "Bouton WhatsApp dédié",
        "whatsappField": "Numéro WhatsApp affiché pour ce produit uniquement",
        "whatsappPlaceholder": "Ex : +225 07 00 00 00 00",
        "buy": "Bouton « Acheter »",
        "buyField": "Lien vers la page ou le paiement",
        "learnMore": "Bouton « En savoir plus »",
        "learnMoreField": "Lien vers plus de détails",
        "call": "Bouton « Appeler »",
        "callField": "Numéro à appeler pour ce produit"
      },
      "preview": {
        "label": "Aperçu",
        "namePlaceholder": "Nom du produit",
        "promoLabel": "Prix promo : {{price}}",
        "featuredBadge": "En avant",
        "hint": "Photo, ambiance et mise en page réelle disponibles juste après la création."
      }
    },
    "index": {
      "searchPlaceholder": "Rechercher…",
      "headerCount_one": "{{count}} produit",
      "headerCount_other": "{{count}} produits",
      "loadingNormal": "Chargement du marché…",
      "loadingSearch": "Recherche en cours…",
      "errorNormal": "Impossible de charger le marché.",
      "errorSearch": "Impossible de lancer la recherche.",
      "emptyNormal": "Aucun produit publié pour le moment.",
      "emptySearch": "Aucun produit ne correspond à cette recherche.",
      "newBadge": "Nouveau",
      "whatsapp": "WhatsApp",
      "contact": "Contacter",
      "contacting": "Ouverture…",
      "buy": "Acheter",
      "learnMore": "En savoir plus",
      "call": "Appeler",
      "seeMore": "Voir plus",
      "goToShop": "Aller en boutique",
      "whatsappMessage": "Bonjour, je suis intéressé(e) par \"{{product}}\" sur Harmonia Market."
    },
    "reglages": {
      "headerTitle": "Réglages",
      "headerSubPro": "Gérez vos boutiques, favoris et abonnements",
      "headerSubStandard": "Vos favoris et boutiques suivies",
      "sections": {
        "subscribedShops": "Boutiques abonnées",
        "favorites": "Favoris",
        "myShops": "Mes boutiques"
      },
      "noSubscribedShops": "Vous ne suivez aucune boutique pour l'instant.",
      "noFavorites": "Aucun produit enregistré pour l'instant.",
      "noMyShops": "Vous n'avez pas encore de boutique.",
      "productsCount_one": "{{count}} produit",
      "productsCount_other": "{{count}} produits",
      "createShopButton": "Créer une nouvelle boutique"
    },
    "gererShop": {
      "notFound": "Boutique introuvable.",
      "sections": {
        "coverPhoto": "Photo de couverture",
        "publicLink": "Lien public",
        "generalInfo": "Informations générales",
        "contacts": "Contacts",
        "location": "Localisation",
        "seo": "Référencement (SEO)",
        "status": "Statut de la boutique",
        "colors": "Couleurs",
        "typography": "Typographie, mise en page, en-tête",
        "products": "Produits",
        "dangerZone": "Zone de danger"
      },
      "colorFields": {
        "primary": "Couleur principale",
        "secondary": "Couleur secondaire",
        "accent": "Couleur d'accent",
        "background": "Couleur de fond",
        "card": "Couleur des cartes",
        "button": "Couleur des boutons",
        "border": "Couleur des bordures",
        "text": "Couleur du texte",
        "link": "Couleur des liens"
      },
      "publicLinkHint": "Cette page est visible par tout le monde, y compris les personnes non connectées. Partagez ce lien pour faire découvrir votre boutique.",
      "publicLinkPending": "Le lien sera disponible une fois la boutique enregistrée.",
      "saveError": "Échec de l'enregistrement — réessayez.",
      "fields": {
        "taglineLabel": "Accroche (tagline)",
        "taglinePlaceholder": "Une phrase qui résume votre boutique",
        "taglineHint": "Max 160 caractères.",
        "descriptionLabel": "Description",
        "descriptionPlaceholder": "Présentez votre boutique en détail",
        "whatsappLabel": "Numéro WhatsApp Business",
        "whatsappPlaceholder": "Ex : +225 07 00 00 00 00",
        "whatsappHint": "Requis si le bouton WhatsApp est activé ci-dessous.",
        "showWhatsappBtn": "Afficher le bouton WhatsApp",
        "showChatBtn": "Afficher le chat de la plateforme",
        "contactEmailLabel": "E-mail de contact",
        "contactEmailPlaceholder": "contact@maboutique.com",
        "contactPhoneLabel": "Téléphone de contact",
        "contactPhonePlaceholder": "Ex : +225 07 00 00 00 00",
        "countryLabel": "Pays",
        "countryPlaceholder": "Ex : Côte d'Ivoire",
        "cityLabel": "Ville",
        "cityPlaceholder": "Ex : Abidjan",
        "addressLabel": "Adresse",
        "addressPlaceholder": "Adresse complète",
        "currencyLabel": "Devise",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Code ISO à 3 lettres majuscules (XOF, EUR, USD…).",
        "languageLabel": "Langue",
        "timezoneLabel": "Fuseau horaire",
        "timezonePlaceholder": "Ex : Africa/Abidjan",
        "seoTitleLabel": "Titre SEO",
        "seoTitlePlaceholder": "Titre affiché dans les résultats de recherche",
        "seoDescriptionLabel": "Description SEO",
        "seoDescriptionPlaceholder": "Résumé affiché sous le titre dans les recherches"
      },
      "statusHint": "Une boutique « Publiée » est visible publiquement, y compris par des personnes non connectées.",
      "typographyPending": "Ces réglages arrivent dans une prochaine étape.",
      "noProducts": "Aucun produit pour l'instant.",
      "cannotLoadProducts": "Impossible de charger les produits.",
      "createProductButton": "Créer un produit",
      "dangerTitle": "Supprimer cette boutique",
      "dangerText": "Cette action est définitive. Tous les produits de cette boutique seront supprimés en même temps qu'elle.",
      "dangerButton": "Supprimer la boutique",
      "deleteModal": {
        "title": "Supprimer « {{name}} » ?",
        "text": "Cette action est irréversible. Tous les produits de cette boutique ({{count}}) seront supprimés définitivement en même temps qu'elle.",
        "confirmLabel": "Pour confirmer, tapez le nom exact de la boutique :",
        "confirmButton": "Supprimer définitivement"
      }
    },
    "gererProduit": {
      "notFound": "Produit introuvable.",
      "saveButton": "Enregistrer",
      "savedBanner": "Modifications enregistrées",
      "saveError": "Échec de l'enregistrement — réessayez.",
      "sections": {
        "publicLink": "Lien public",
        "photos": "Photos",
        "essential": "Essentiel",
        "details": "Détails",
        "advanced": "Options avancées",
        "seo": "Référencement (SEO)",
        "dangerZone": "Zone de danger"
      },
      "publicLinkHint": "Cette page est visible par tout le monde, y compris les personnes non connectées. Partagez ce lien pour faire découvrir ce produit.",
      "publicLinkPending": "Le lien sera disponible une fois le produit enregistré.",
      "fields": {
        "mainPhoto": "Photo principale",
        "photo2": "Photo 2",
        "photo3": "Photo 3",
        "photo3Hint": "La photo 3 nécessite que la photo 2 soit déjà renseignée.",
        "nameLabel": "Nom du produit *",
        "namePlaceholder": "Ex : Collier perles wax",
        "priceLabel": "Prix ({{currency}}) *",
        "pricePlaceholder": "Ex : 8000",
        "categoryLabel": "Catégorie",
        "statusLabel": "Statut",
        "descriptionShortLabel": "Description courte",
        "descriptionShortPlaceholder": "Une phrase qui donne envie",
        "descriptionLabel": "Description complète",
        "descriptionPlaceholder": "Détaillez les caractéristiques…",
        "brandLabel": "Marque",
        "brandPlaceholder": "Ex : Fabriqué maison, Nike…",
        "conditionLabel": "État",
        "stockLabel": "Stock disponible",
        "stockPlaceholder": "Ex : 12",
        "promoPriceLabel": "Prix promotionnel",
        "promoPricePlaceholder": "Doit être ≤ prix normal",
        "currencyLabel": "Devise",
        "currencyPlaceholder": "XOF",
        "currencyHint": "Code ISO à 3 lettres.",
        "featuredLabel": "Mettre en avant ce produit",
        "showChatLabel": "Afficher le chat de la plateforme",
        "seoTitleLabel": "Titre SEO",
        "seoTitlePlaceholder": "Titre affiché dans les résultats de recherche",
        "seoDescriptionLabel": "Description SEO",
        "seoDescriptionPlaceholder": "Résumé affiché sous le titre"
      },
      "actionButtons": {
        "groupLabel": "Boutons d'action",
        "whatsapp": "Bouton WhatsApp dédié",
        "whatsappHint": "Numéro spécifique à ce produit.",
        "whatsappPlaceholder": "Ex : +225 07 00 00 00 00",
        "buy": "Bouton « Acheter »",
        "learnMore": "Bouton « En savoir plus »",
        "call": "Bouton « Appeler »",
        "callPlaceholder": "Ex : +225 07 00 00 00 00"
      },
      "dangerTitle": "Supprimer ce produit",
      "dangerText": "Cette action est définitive et ne peut pas être annulée.",
      "dangerButton": "Supprimer le produit",
      "deleteModal": {
        "title": "Supprimer « {{name}} » ?",
        "text": "Cette action est irréversible.",
        "confirmButton": "Supprimer"
      }
    },
    "components": {
      "categoryChips": {
        "loading": "Chargement des catégories…",
        "error": "Impossible de charger les catégories.",
        "allLabel": "Toutes"
      },
      "colorPicker": {
        "cancel": "Annuler",
        "confirm": "Valider"
      },
      "detailProduit": {
        "newBadge": "Nouveau",
        "inStock": "En stock ({{count}})",
        "outOfStock": "Rupture de stock",
        "descriptionTitle": "Description",
        "whatsapp": "Contacter via WhatsApp",
        "contactSeller": "Contacter le vendeur",
        "contacting": "Ouverture…",
        "buy": "Acheter",
        "learnMore": "En savoir plus",
        "call": "Appeler",
        "goToShop": "Aller en boutique",
        "whatsappMessage": "Bonjour, je suis intéressé(e) par \"{{product}}\" sur Harmonia Market."
      },
      "searchBar": {
        "placeholder": "Rechercher…"
      },
      "shopHeader": {
        "productsLabel": "Produits",
        "subscribersLabel": "Abonnés",
        "subscribed": "Abonné",
        "subscribe": "S'abonner",
        "subscribing": "…"
      },
      "imagePicker": {
        "change": "Changer",
        "add": "Ajouter une image",
        "sessionExpired": "Session expirée.",
        "uploadError": "Échec de l'upload."
      }
    },
    "produitDetail": {
      "loading": "Chargement du produit…",
      "notFound": "Ce produit n'existe pas ou n'est plus disponible.",
      "cannotLoad": "Impossible de charger ce produit."
    },
    "boutiqueDetail": {
      "loading": "Chargement de la boutique…",
      "notFound": "Cette boutique n'existe pas ou n'est plus disponible.",
      "cannotLoad": "Impossible de charger cette boutique.",
      "shopNotFound": "Boutique introuvable.",
      "newBadge": "Nouveau",
      "productsTitle": "Produits",
      "cannotLoadProducts": "Impossible de charger les produits.",
      "noProducts": "Aucun produit publié pour l'instant."
    }
  }
}
